export enum TFAMethodTypes {
  'APP' = 'app',
  'KEY' = 'cross-platform',
  'OS' = 'platform',
}
